import React from 'react';

const QrShareActions = ({ shareValue, linkText = 'Share this View', onDownloadSvg, onDownloadPng }) => {
  const hasShareValue = Boolean(shareValue);
  const linkLabel = `🔗 ${linkText}`;

  return (
    <div className="mt-3">
      <div className="flex justify-center gap-2">
        <button
          type="button"
          className={`rounded-lg border border-gray-300 px-3 py-1 text-xs font-semibold ${
            hasShareValue ? 'text-gray-700 hover:bg-gray-100' : 'cursor-not-allowed text-gray-400'
          }`}
          onClick={onDownloadSvg}
          disabled={!hasShareValue || !onDownloadSvg}
        >
          Download SVG
        </button>
        {onDownloadPng && (
          <button
            type="button"
            className={`rounded-lg border border-gray-300 px-3 py-1 text-xs font-semibold ${
              hasShareValue ? 'text-gray-700 hover:bg-gray-100' : 'cursor-not-allowed text-gray-400'
            }`}
            onClick={onDownloadPng}
            disabled={!hasShareValue}
          >
            Download PNG
          </button>
        )}
      </div>
      <div className="mt-3 text-xs font-semibold text-gray-600">URL</div>
      {hasShareValue ? (
        <a
          href={shareValue}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-1 block break-all text-xs text-blue-600 underline"
          title={shareValue}
        >
          {linkLabel}
        </a>
      ) : (
        <div className="mt-1 text-xs text-gray-500">No URL available.</div>
      )}
    </div>
  );
};

export default QrShareActions;
